export default __webpack_public_path__ + "static/media/video-icon-active.490e4e98.svg";